// extracted by mini-css-extract-plugin
export default {"headLottie":"style_headLottie__LMypw"};